import { LegalLayout } from "@/components/legal/LegalLayout";
import { useI18n } from "@/i18n";

export default function Terms() {
  const { t } = useI18n();
  return <LegalLayout page="terms" path="/terms" content={t("legal.terms")} testid="terms-page" />;
}
